import { createStyles, makeStyles } from '@hawkins/styles';
export function timePickerStyles(theme) {
    var _a, _b;
    var hawkins = theme.hawkins, hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    var optionGap = hawkinsVariables.spacings.space0;
    var optionHeight = hawkinsVariables.sizingValues.size4;
    return createStyles({
        /** Class name of each hour/minute/second/period option. */
        option: {
            alignItems: 'center',
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
            color: hawkins.textColor.textColorRegular,
            cursor: 'pointer',
            display: 'flex',
            flexShrink: 0,
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            fontSize: hawkins.body.fontSize0,
            height: optionHeight,
            justifyContent: 'center',
            width: hawkinsVariables.sizings.size5,
        },
        /** Class name of each option when it is disabled. */
        optionDisabled: {
            color: hawkins.textColor.textColorXlight,
            cursor: 'not-allowed',
        },
        /** Class name of each option when it is not disabled. */
        optionEnabled: (_a = {},
            _a[hawkinsUtils.getHoveredElementSelector('&')] = hawkinsUtils.getFocusRingedElementStyle(),
            _a),
        /** Class name of each option when it is selected. */
        optionSelected: {
            backgroundColor: hawkins.state.backgroundColorSelected,
        },
        /** Class name of each element containing a set of hour/minute/second/period options. */
        optionsContainer: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            gap: optionGap,
            overflowY: 'scroll',
            // This element needs to be positioned in order for our JS scrolling logic to work.
            position: 'relative',
            scrollbarWidth: 'none' /* Firefox */,
            '&::-webkit-scrollbar': { display: 'none' } /* Safari and Chrome */,
            '-ms-overflow-style': 'none' /* Internet Explorer 10+ */,
        },
        /** Class name of each options container that is scrollable. */
        optionsContainerScrollable: {
            '& $option': {
                // Leave room since we adjust the scroll position by 1 pixel if the options container
                // is scrollable and starts out at the top or bottom of its scroll height.
                '&:first-child': { marginTop: 1 },
                '&:last-child': { marginBottom: 1 },
            },
        },
        /**
         * Class name of each element containing an hour/minute/second/period picker section
         * (a section contains the options and scroll buttons).
         */
        optionsSection: {
            display: 'flex',
            flexDirection: 'column',
            gap: optionGap,
        },
        /** Class name of the root element. */
        root: {
            display: 'flex',
            gap: hawkinsVariables.spacings.space0,
            height: optionHeight * 7.4,
            padding: hawkinsVariables.spacings.space3,
        },
        /** Class name of each scroll button. */
        scrollButton: (_b = {
                alignItems: 'center',
                borderRadius: hawkinsVariables.borderRadius.borderRadius0,
                color: hawkins.icon.fillLight,
                cursor: 'pointer',
                display: 'flex',
                flexShrink: 0,
                height: optionHeight,
                justifyContent: 'center',
                width: hawkinsVariables.sizings.size5
            },
            _b[hawkinsUtils.getHoveredElementSelector('&')] = {
                backgroundColor: hawkins.state.backgroundColorHover,
                color: hawkins.icon.fillRegular,
            },
            _b),
        /** Class name of each hidden scroll button. */
        scrollButtonHidden: {
            visibility: 'hidden',
        },
    });
}
export var useTimePickerStyles = makeStyles(timePickerStyles, { name: 'Hawkins-TimePicker' });
